// AUTO-GENERATED by scripts/build-documents.mjs — do not edit by hand.
// Drop files into public/documents/ and re-run `npm run documents`.
import type { DocItem } from '../types.js';

export const DOCUMENTS: DocItem[] = [
	{
		"id": "01 AUG - BUS - SEO Train.pdf",
		"name": "01 AUG BUS SEO Train",
		"url": "/documents/01%20AUG%20-%20BUS%20-%20SEO%20Train.pdf",
		"filename": "01 AUG - BUS - SEO Train.pdf",
		"ext": ".pdf",
		"kind": "pdf",
		"size": 118555
	},
	{
		"id": "25 JUL - SEO - JEJ Flight.pdf",
		"name": "25 JUL SEO JEJ Flight",
		"url": "/documents/25%20JUL%20-%20SEO%20-%20JEJ%20Flight.pdf",
		"filename": "25 JUL - SEO - JEJ Flight.pdf",
		"ext": ".pdf",
		"kind": "pdf",
		"size": 71594
	},
	{
		"id": "28 JUL - JEJ - BUS Flight.pdf",
		"name": "28 JUL JEJ BUS Flight",
		"url": "/documents/28%20JUL%20-%20JEJ%20-%20BUS%20Flight.pdf",
		"filename": "28 JUL - JEJ - BUS Flight.pdf",
		"ext": ".pdf",
		"kind": "pdf",
		"size": 56080
	},
	{
		"id": "ACCOMMODATION.pdf",
		"name": "ACCOMMODATION",
		"url": "/documents/ACCOMMODATION.pdf",
		"filename": "ACCOMMODATION.pdf",
		"ext": ".pdf",
		"kind": "pdf",
		"size": 249286
	},
	{
		"id": "INTERNATIONAL FLIGHTS.pdf",
		"name": "INTERNATIONAL FLIGHTS",
		"url": "/documents/INTERNATIONAL%20FLIGHTS.pdf",
		"filename": "INTERNATIONAL FLIGHTS.pdf",
		"ext": ".pdf",
		"kind": "pdf",
		"size": 315109
	},
	{
		"id": "NOTES.pdf",
		"name": "NOTES",
		"url": "/documents/NOTES.pdf",
		"filename": "NOTES.pdf",
		"ext": ".pdf",
		"kind": "pdf",
		"size": 3093776
	},
	{
		"id": "Tevlen_Certificate_of_Insurance.pdf",
		"name": "Tevlen Certificate of Insurance",
		"url": "/documents/Tevlen_Certificate_of_Insurance.pdf",
		"filename": "Tevlen_Certificate_of_Insurance.pdf",
		"ext": ".pdf",
		"kind": "pdf",
		"size": 189124
	},
	{
		"id": "Tevlen_Chopsticks.pdf",
		"name": "Tevlen Chopsticks",
		"url": "/documents/Tevlen_Chopsticks.pdf",
		"filename": "Tevlen_Chopsticks.pdf",
		"ext": ".pdf",
		"kind": "pdf",
		"size": 2111444
	},
	{
		"id": "Tevlen_Everland_Ticket.pdf",
		"name": "Tevlen Everland Ticket",
		"url": "/documents/Tevlen_Everland_Ticket.pdf",
		"filename": "Tevlen_Everland_Ticket.pdf",
		"ext": ".pdf",
		"kind": "pdf",
		"size": 89388
	},
	{
		"id": "Tevlen_Seoul_Tour.pdf",
		"name": "Tevlen Seoul Tour",
		"url": "/documents/Tevlen_Seoul_Tour.pdf",
		"filename": "Tevlen_Seoul_Tour.pdf",
		"ext": ".pdf",
		"kind": "pdf",
		"size": 628446
	},
	{
		"id": "Tevlen_Travel_Insurance_Details.pdf",
		"name": "Tevlen Travel Insurance Details",
		"url": "/documents/Tevlen_Travel_Insurance_Details.pdf",
		"filename": "Tevlen_Travel_Insurance_Details.pdf",
		"ext": ".pdf",
		"kind": "pdf",
		"size": 443807
	},
	{
		"id": "Thendral_Certificate_of_Insurance.pdf",
		"name": "Thendral Certificate of Insurance",
		"url": "/documents/Thendral_Certificate_of_Insurance.pdf",
		"filename": "Thendral_Certificate_of_Insurance.pdf",
		"ext": ".pdf",
		"kind": "pdf",
		"size": 189136
	},
	{
		"id": "Thendral_Chopsticks.jpeg",
		"name": "Thendral Chopsticks",
		"url": "/documents/Thendral_Chopsticks.jpeg",
		"filename": "Thendral_Chopsticks.jpeg",
		"ext": ".jpeg",
		"kind": "image",
		"size": 168461
	},
	{
		"id": "Thendral_Everland_Ticket.pdf",
		"name": "Thendral Everland Ticket",
		"url": "/documents/Thendral_Everland_Ticket.pdf",
		"filename": "Thendral_Everland_Ticket.pdf",
		"ext": ".pdf",
		"kind": "pdf",
		"size": 90062
	},
	{
		"id": "Thendral_Seoul_Tour.jpeg",
		"name": "Thendral Seoul Tour",
		"url": "/documents/Thendral_Seoul_Tour.jpeg",
		"filename": "Thendral_Seoul_Tour.jpeg",
		"ext": ".jpeg",
		"kind": "image",
		"size": 195983
	},
	{
		"id": "Thendral_Travel_Insurance_Details.pdf",
		"name": "Thendral Travel Insurance Details",
		"url": "/documents/Thendral_Travel_Insurance_Details.pdf",
		"filename": "Thendral_Travel_Insurance_Details.pdf",
		"ext": ".pdf",
		"kind": "pdf",
		"size": 443807
	}
];
